module.exports = __webpack_public_path__ + "static/icons/icon-js.301a1c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-js.svg
// module id = GINX
// module chunks = 1